import React from "react";
import { motion } from "framer-motion";
import { Flame } from "lucide-react";

export const streakMultiplier = (days = 0) => 1.0 + Math.min(Math.max(days, 0), 10) * 0.1;

export const StreakBadge = ({ days = 0, size = "md", className = "", testid = "streak-badge", showBonus = false }) => {
  const lit = days > 0;
  const dims = size === "sm" ? "h-8 px-2.5 text-sm" : size === "lg" ? "h-12 px-4 text-xl" : "h-10 px-3 text-base";
  const iconSize = size === "sm" ? 14 : size === "lg" ? 20 : 16;
  const mult = streakMultiplier(days);
  const bonusPct = Math.round((mult - 1) * 100);

  return (
    <motion.div
      initial={{ scale: 0.9, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      whileHover={{ scale: 1.05 }}
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 rounded-full border font-display font-bold ${dims} ${
        lit
          ? "bg-gradient-to-r from-red-500/20 to-yellow-400/20 border-yellow-300/40 text-yellow-100"
          : "bg-white/5 border-white/10 text-white/50"
      } ${className}`}
      title={lit ? `${days}-day streak · +${bonusPct}% reward bonus (cap 10 days / +100%)` : "Do a lesson, mission, or quiz today to start your streak"}
    >
      <Flame size={iconSize} className={lit ? "text-yellow-300" : "text-white/40"} fill={lit ? "currentColor" : "none"} />
      <span>{days}</span>
      <span className="text-[10px] uppercase tracking-widest opacity-70">{days === 1 ? "day" : "days"}</span>
      {showBonus && lit && (
        <span className="text-[10px] uppercase tracking-widest px-1.5 py-0.5 rounded-full bg-yellow-300/25 text-yellow-100 border border-yellow-300/40">+{bonusPct}%</span>
      )}
    </motion.div>
  );
};

export default StreakBadge;
